module.exports = __webpack_public_path__ + "78a7bd49432296731ad2005128695dc9.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-320.webp
// module id = 376
// module chunks = 0